module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - PARTNER")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('partner_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('partner_2')) + "            ")]), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-partner.jpeg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bca332c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner.vue
// module id = 1389
// module chunks = 1